"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function flattenNodeGenerator(param) {
    var node = param.node, parent = param.parent, index = param.index, settings = param.settings, stack = param.stack, pid = param.pid, tLevel = param.tLevel;
    return function (list) {
        var childKey = settings.childrenKeyName;
        node = settings.initNode(node);
        node.id = node.id || settings.generateUniqueId();
        node.parentId = node.parentId || pid;
        node.tLevel = node.tLevel || tLevel;
        node.isRoot = node.isRoot || !!node[childKey];
        list.push(node);
        if (node[childKey]) {
            for (var i = 0, len = node[childKey].length; i < len; i++) {
                stack.push(flattenNodeGenerator({
                    node: node[childKey][i],
                    parent: node,
                    index: i,
                    settings: settings,
                    stack: stack,
                    pid: node.id,
                    tLevel: tLevel + 1,
                }));
            }
        }
        if (parent && typeof parent !== "string" && parent[childKey]) {
            parent[childKey][index] = node.id;
        }
        return list;
    };
}
function flattenTree(tree, options) {
    options = options || {};
    var settings = {
        initNode: options.initNode ||
            function (node) {
                return node;
            },
        parentIdStart: options.parentIdStart || 0,
        uniqueIdStart: options.parentIdStart
            ? Number(options.parentIdStart) + 1
            : 1,
        generateUniqueId: options.generateUniqueId ||
            function () {
                return settings.uniqueIdStart++;
            },
        childrenKeyName: options.childrenKeyName || "children",
    };
    var list = [];
    var stack = [];
    for (var i = 0, len = tree.length; i < len; i++) {
        stack.push(flattenNodeGenerator({
            node: tree[i],
            parent: "root",
            index: i,
            settings: settings,
            stack: stack,
            pid: settings.parentIdStart,
            tLevel: 1,
        }));
    }
    while (stack.length) {
        // @ts-ignore:
        list = stack.shift()(list);
    }
    return list;
}
exports.default = flattenTree;
